import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef} from '@angular/core';
import {BingMapMarker} from '../../../../bing-maps/bing-map-marker';
import {BingMapService} from '../../../../bing-maps/service/bing-map.service';
import {Library} from '../library-list/library.model';
import {HtmlUtilsService} from '../../../../html-utils/html-utils.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ExtLinkModalComponent} from '../ext-link-modal/ext-link-modal.component';
import {AlephService} from './aleph.service';
import {BingMapsMobileService} from '../../../../bing-maps/service/bing-maps-mobile.service';
import {Subscription} from 'rxjs';
import {UserPositionService} from '../../../../bing-maps/service/user-position.service';
import { flatMap, add, sumBy, sortBy } from 'lodash';
import {AuthService} from '../../../../auth/auth.service';

@Component({
  selector: 'app-library-item',
  templateUrl: './library-item.component.html',
  styleUrls: ['./library-item.component.scss']
})
export class LibraryItemComponent implements OnInit, OnChanges, OnDestroy {

  _lib: Library;

  _externalUrls: any[] = [];

  @Input() public hideMaterializationCount;

  simpleMobileMarker: BingMapMarker;
  highContrast: boolean = false;

  @Input() set lib(value: Library) {
    this._lib = value;

    if (value.items) {
      this._externalUrls = sortBy(value.items.filter(item => item.url).map(item => this.createUrlObject(item)), ['pubDate']).reverse();
    }

    if (this._externalUrls.length === 0 && value.url) {
      this._externalUrls = [this.createUrlObject(value)];
    }
     this.simpleMobileMarker = this._lib.toBindMapMarkerSimple();

  }

  @Input() showDistanceLabels: boolean;

  @Input() libNumber: number;

  @Input() pageNumber = 1;

  @Input() pageSize = 20;

  @Input() institutionsView;

  fullPageVersion = false;

  @ViewChild('mapContainer', {read: ViewContainerRef}) mapContainer: ViewContainerRef;

  @ViewChild(TemplateRef) mobileMapInstance;

  alephReady = false;

  alephAvailable = 0;

  alephCount = 0;

  alephError = false;

  alephStatus = false;

  alephItemCount;

  alephServiceSubscription: Subscription;

  constructor(protected modalService: NgbModal,
              private mapsService: BingMapService,
              private mapsMobileService: BingMapsMobileService,
              private alephService: AlephService,
              public htmlUtils: HtmlUtilsService,
              public authService: AuthService,
              private positionService: UserPositionService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.highContrast = this.htmlUtils.contrast;
    this.htmlUtils.highContrast.subscribe((value) => {
      if (value !== this.highContrast) {
        this.highContrast = value;
      }
    });
  }

  ngOnInit() {
    this.fullPageVersion = this.htmlUtils.fullPageVersion;
    this.htmlUtils.fullPageBehaviorSubject.subscribe(fullPageVersion => {
      this.fullPageVersion = fullPageVersion;
    });
    if (!this.institutionsView) {
      this.subscribeToCheckAvability(this._lib.items);
    }
  }

  ngOnDestroy(): void {
    if (this.alephServiceSubscription) {
      this.alephServiceSubscription.unsubscribe();
    }
  }


  isSelected() {
    return this.mapsMobileService.selectedLib == this._lib;
  }

  createUrlObject (item) {
    return {
      url: item.url.toLowerCase().startsWith('http') ? item.url : `http://${item.url}`,
      info: item.editionInfo,
      pubDate: item.pubDate
    }
  }

  public subscribeToCheckAvability(items) {
    const materializationIdsMap = flatMap(items, 'itemLocalMatId');
    if (!this.alephServiceSubscription) {
        this.alephServiceSubscription = this.alephService.getAvailability(
          materializationIdsMap, this._externalUrls[0].url).subscribe(bookAvailability => {
          materializationIdsMap.forEach((materialization) => {
            this.alephAvailable = add(this.alephAvailable, bookAvailability.items[materialization].available);
            this.alephCount = add(this.alephCount, bookAvailability.items[materialization].total);
            this.alephStatus = bookAvailability.items[materialization].status === 'UNKNOWN';
            if (this.alephStatus) this.alephItemCount = sumBy(this._lib.items, 'itemCount');
          });
          this.alephReady = true;
        }, error1 => {
          this.alephError = true;
        });
    }

  }


  showMore() {
    const modalInstance = this.modalService.open(ExtLinkModalComponent);
    modalInstance.componentInstance.externalUrls = this._externalUrls;
  }

  preventDef(event) {
    if (event) {
      event.preventDefault();
    }
  }

  showRoute() {
    if (this._lib) {
      if (this.mapsMobileService.selectedLib == this._lib) {
        this.mapsMobileService.selectedLib = null;
      } else {
        this.mapsMobileService.selectedLib = this._lib;
        this.getRoute(!this.fullPageVersion);
      }
    }
  }

  getRoute(isMobile: boolean) {
    if (isMobile) {
      this.mapsMobileService.selectedLib = this._lib;
      this.createMobileRouteBeetwenPoints();
    } else {
      this.createRouteBeetwenPoints();
    }
  }

  private createRouteBeetwenPoints() {
    if (this.isValid(this._lib)) {
      this.mapsService.getRouteToTarget(new BingMapMarker(this._lib.lat, this._lib.lon, this._lib.online), this._lib.name);
    }
  }

  private createMobileRouteBeetwenPoints(){
    if (this.isValid(this._lib)) {
      this.mapsMobileService.getRouteToTarget(new BingMapMarker(this._lib.lat, this._lib.lon, this._lib.online), this._lib.name);
    }
  }

  getDistanceLabel() {
    if (this.isValid(this._lib)) {
      const distance = this.positionService.createDistanceLabel(new BingMapMarker(this._lib.lat, this._lib.lon, this._lib.online), this.mapsService.accessDenied);
      return distance === '' ? '' : `(${distance})`;
    }
  }

  isPublicDomain(_lib: Library) {
    return _lib.items && _lib.items.filter((value: { publicDomain: boolean }) => value.publicDomain).length > 0
  }

  hitPersonalization() {
  }

  private isValid(_li: Library): boolean{
    return !this._lib.online && this._lib.lat && this._lib.lat !== null && this._lib.lon && this._lib.lon !== null;
  }

  private canVerifyAleph() {
    return !!this._lib && !!this._lib.items && this._lib.items.length>0 && !!this._lib.items[0].itemPublicationId
      && !!this._lib.items[0].itemServiceUrl && !!this._lib.items[0].itemLocalBibId;
  }

}
